import React, { useState, useEffect } from "react";
import "./banner-carousel.scss";

interface BannerSlide {
  id: number;
  image: string;
  title: string;
  subtitle: string;
  cta: string;
  ctaText: string;
}

interface BannerCarouselProps {
  slides: BannerSlide[];
  onClose?: () => void;
}

const BannerCarousel: React.FC<BannerCarouselProps> = ({ slides, onClose }) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const goToSlide = (index: number) => {
    setCurrentSlide(index % slides.length);
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const slide = slides[currentSlide];

  if (!slide) return null;

  return (
    <div className="banner-carousel">
      {/* Main Banner */}
      <div className="banner-carousel-slide">
        <img src={slide.image} alt={slide.title} className="banner-carousel-image" />

        {/* Content Overlay */}
        <div className="banner-carousel-content">
          <h1 className="banner-carousel-title">{slide.title}</h1>
          <p className="banner-carousel-subtitle">{slide.subtitle}</p>
          <button className="banner-carousel-cta">{slide.ctaText}</button>
        </div>

        {/* Navigation Arrows */}
        <button
          className="banner-carousel-arrow banner-carousel-arrow-prev"
          onClick={prevSlide}
          aria-label="Previous slide"
        >
          <i className="pi pi-chevron-left" />
        </button>
        <button
          className="banner-carousel-arrow banner-carousel-arrow-next"
          onClick={nextSlide}
          aria-label="Next slide"
        >
          <i className="pi pi-chevron-right" />
        </button>
      </div>

      {/* Pagination Dots */}
      <div className="banner-carousel-pagination">
        {slides.map((_, index) => (
          <button
            key={index}
            className={`banner-carousel-dot ${
              index === currentSlide ? "active" : ""
            }`}
            onClick={() => goToSlide(index)}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>

      {/* Close Button */}
      {onClose && (
        <button className="banner-carousel-close" onClick={onClose}>
          <i className="pi pi-times" />
        </button>
      )}
    </div>
  );
};

export default BannerCarousel;
